import { useState } from "react";
import { Alert, Button, Divider, Stack, Typography } from "@mui/material";
import { Link } from "react-router-dom";
import { PlatformPage } from "@/components/PlatformPage";
import { useModuleOfferDrafts } from "../hooks/useModuleOfferAuthoring";

export function ModuleOfferDraftIndexPage() {
  const [offset, setOffset] = useState(0);
  const query = useModuleOfferDrafts({ offset });
  return (
    <PlatformPage
      title="Module offer drafts"
      isLoading={query.isPending}
      actions={
        <Button
          size="small"
          variant="contained"
          component={Link}
          to="/contracts/module-offers/new"
        >
          New module offer draft
        </Button>
      }
    >
      {query.isError ? (
        <Alert severity="warning">
          Current module drafts unavailable. Verified Admin access is required.{" "}
          <Button size="small" onClick={() => void query.refetch()}>
            Retry
          </Button>
        </Alert>
      ) : query.data ? (
        <Stack spacing={2.5} divider={<Divider />}>
          {!query.data.items.length ? (
            <Typography>No module offer drafts returned.</Typography>
          ) : (
            query.data.items.map((draft) => (
              <Stack key={draft.draft_id} spacing={1}>
                <Typography component="h2" variant="h6">
                  {draft.title}
                </Typography>
                <Typography variant="body2">
                  {draft.module_key} · {draft.economics.cadence} · revision{" "}
                  {draft.revision}
                </Typography>
                <Stack direction="row" spacing={1}>
                  <Button
                    size="small"
                    variant="outlined"
                    component={Link}
                    to={`/contracts/module-offers/${draft.draft_id}`}
                  >
                    Edit draft
                  </Button>
                  <Button
                    size="small"
                    variant="outlined"
                    component={Link}
                    to={`/contracts/module-offers/${draft.draft_id}/publication`}
                  >
                    Review publication candidate
                  </Button>
                </Stack>
              </Stack>
            ))
          )}
          <Stack direction="row" spacing={1} sx={{ alignItems: "center" }}>
            <Typography variant="body2">
              {query.data.total} total drafts
            </Typography>
            <Button
              size="small"
              disabled={offset === 0}
              onClick={() => setOffset(Math.max(0, offset - query.data!.limit))}
            >
              Previous
            </Button>
            <Button
              size="small"
              disabled={offset + query.data.limit >= query.data.total}
              onClick={() => setOffset(offset + query.data!.limit)}
            >
              Next
            </Button>
          </Stack>
        </Stack>
      ) : null}
    </PlatformPage>
  );
}
